import { render, staticRenderFns } from "./StockManage.vue?vue&type=template&id=3c425290&scoped=true&"
import script from "./StockManage.vue?vue&type=script&lang=js&"
export * from "./StockManage.vue?vue&type=script&lang=js&"
import style0 from "./StockManage.vue?vue&type=style&index=0&id=3c425290&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c425290",
  null
  
)

export default component.exports